import styled from 'styled-components/macro'
import { themeGet } from '@styled-system/theme-get'
import { FlexColumn, FlexRow } from 'src/components/Reusable/Flex'
import { DerivedResizableTextArea } from 'src/components/Reusable/Inputs/TextInput/TextInput'

export const RequirementsList = styled(FlexColumn)`
  width: 100%;
  gap: 16px;
`

export const RequirementCard = styled.div`
  width: 100%;
  border: 1px solid ${themeGet('colors.border.neutral.light')};
  border-radius: 12px;
  background-color: ${themeGet('colors.bg.neutral')};
  padding: 16px;
`

export const RequirementCardHeader = styled(FlexRow)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`

export const RequirementCardTitle = styled.p`
  margin: 0;
  font-weight: 600;
`

export const RequirementFields = styled(FlexColumn)`
  width: 100%;
  gap: 16px;
`

export const RequirementFieldRow = styled(FlexRow)`
  width: 100%;
  gap: 12px;
  align-items: flex-start;
  flex-wrap: wrap;
`

export const RequirementField = styled.div`
  flex: 1 1 280px;
  min-width: 0;
`

export const RequirementDescriptionInput = styled(DerivedResizableTextArea)`
  &[class^='StyledTextInput'],
  > *[class^='StyledTextInput'] {
    min-height: 96px;
    height: 96px;
  }
`
